import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";

import HelpButton from "common/components/HelpButton";
import If from "common/components/if";

/**
 * Displays a "search" button, and optionally a "help" link and "restore defaults" button.
 * Used by Weather and Bulletin search input.
 * See propTypes for param details.
 * This component holds no state.
 */
function SearchInputControls({ onSearch, onRestoreDefaults, helpUrl }) {
  return (
    <div className="buttons">
      <div className="search-button-wrapper">
        <div className="btn btn-primary search-button" onClick={onSearch}>
          <span>
            <FormattedMessage id="search" />
          </span>
        </div>
        <HelpButton helpUrl={helpUrl} />
      </div>
      <If condition={!!onRestoreDefaults}>
        <div
          className="btn btn-secondary search-button"
          onClick={onRestoreDefaults}
        >
          <span>
            <FormattedMessage id="restoreDefaults" />
          </span>
        </div>
      </If>
    </div>
  );
}

SearchInputControls.propsTypes = {
  // An optional url string. If provided, the component will display a clickable help icon. Otherwise blank.
  helpUrl: PropTypes.string,
  // A callback function called when the user clicks the search button
  onSearch: PropTypes.func.isRequired,
  // A callback function called when the user clicks the restore defaults button.
  // If this function is not provided, the restore defaults button is not displayed.
  onRestoreDefaults: PropTypes.func
};

export default injectIntl(SearchInputControls);
